import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web/slate/Color";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { useChatCsatStore } from "../hooks/ChatCsatContextStore";
import { ChatCsatHeader } from "./ChatCsatHeader";
export var ChatCsatWrapper = function ChatCsatWrapper(_ref) {
  var children = _ref.children;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var _useChatCsatStore = useChatCsatStore(["surveyType"]),
    _useChatCsatStore2 = _slicedToArray(_useChatCsatStore, 1),
    surveyType = _useChatCsatStore2[0].surveyType;
  if (surveyType === "chat") {
    return /*#__PURE__*/React.createElement(ChatWrapper, null, children);
  }
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ChatCsatHeader, null), /*#__PURE__*/React.createElement(InnerWrapper, null, /*#__PURE__*/React.createElement(Row, {
    justify: "center",
    align: "center"
  }, isMobile ? null : /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(BackgroundWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Container, null, children))), isMobile ? null : /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }))));
};
var Container = styled(Column).withConfig({
  displayName: "ChatCsatWrapper__Container"
})(["max-width:480px;input{opacity:0;}"]);
var ContentWrapper = styled(Column).attrs({
  align: "center"
}).withConfig({
  displayName: "ChatCsatWrapper__ContentWrapper"
})(["margin:", ";padding:", ";background-color:", ";min-height:100%;height:75vh;width:100%;", "{padding:", ";}"], getSpacing("4x", 0), getSpacing("4x", "5x"), Core.surface.inverse, responsiveMediaQueries.mobile, getSpacing("1x"));
var InnerWrapper = styled(Column).withConfig({
  displayName: "ChatCsatWrapper__InnerWrapper"
})(["", "{background-color:", ";}flex:auto;"], responsiveMediaQueries.tabletAndAbove, Core.surface.muted + Opacity.O_80);
var Wrapper = styled(Column).withConfig({
  displayName: "ChatCsatWrapper__Wrapper"
})(["width:100%;background-color:transparent;height:auto;min-height:100vh;"]);
var ChatWrapper = styled.div.withConfig({
  displayName: "ChatCsatWrapper__ChatWrapper"
})(["display:flex;flex-direction:column;justify-content:center;height:100%;input{opacity:0;}padding:", ";"], getSpacing(0, "3x", 0, "3x"));
var BackgroundWrapper = styled.div.withConfig({
  displayName: "ChatCsatWrapper__BackgroundWrapper"
})(["", "{width:100%;}", "{width:85%;}", "{width:1150px;}height:100%;"], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.desktop, responsiveMediaQueries.xLargeAndAbove);